document.addEventListener('click', async function (event) {
  const button = event.target.closest('.complete-look-add-button');
  if (!button) return;

  event.preventDefault();

  const handle = button.dataset.completeLookHandle;
  const response = await fetch(`/products/${handle}.js`);
  const product = await response.json();

  const modal = document.createElement('div');
  modal.className = 'complete-look-modal';

  modal.innerHTML = `
    <div class="complete-look-modal__overlay"></div>
    <div class="complete-look-modal__box">
      <button class="complete-look-modal__close" type="button">×</button>

      <div class="complete-look-modal__grid">
        <img class="complete-look-modal__image" src="${product.featured_image}" alt="${product.title}">

        <div>
          <h3>${product.title}</h3>

          <div class="complete-look-modal__price">
            <div class="complete-look-price__new"></div>
            <div class="complete-look-price__bottom">
              <span class="complete-look-price__old"></span>
              <span class="complete-look-price__save">Save 10%</span>
            </div>
          </div>

          <select class="complete-look-modal__select">
            ${product.variants
              .filter(variant => variant.available)
              .map(variant => `
                <option
                  value="${variant.id}"
                  data-image="${variant.featured_image ? variant.featured_image.src : product.featured_image}"
                  data-price="${variant.price}">
                  ${variant.title}
                </option>
              `)
              .join('')}
          </select>

          <button class="complete-look-modal__add" type="button">add to cart</button>
        </div>
      </div>
    </div>
  `;

  document.body.appendChild(modal);

  const select = modal.querySelector('.complete-look-modal__select');
  const image = modal.querySelector('.complete-look-modal__image');
  const newPrice = modal.querySelector('.complete-look-price__new');
  const oldPrice = modal.querySelector('.complete-look-price__old');

  function formatPrice(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function updateVariant() {
    const option = select.options[select.selectedIndex];
    const original = Number(option.dataset.price);
    const discounted = Math.round(original * 0.9);

    image.src = option.dataset.image;
    newPrice.textContent = formatPrice(discounted);
    oldPrice.textContent = formatPrice(original);
  }

  updateVariant();

  select.addEventListener('change', updateVariant);

  modal.querySelector('.complete-look-modal__close').onclick = () => modal.remove();
  modal.querySelector('.complete-look-modal__overlay').onclick = () => modal.remove();

  modal.querySelector('.complete-look-modal__add').onclick = async () => {
    const variantId = Number(select.value);

    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
  id: variantId,
  quantity: 1,
  properties: {
    "_complete_the_look": "true"
  }
})
    });

    if (!addResponse.ok) {
      const error = await addResponse.json();
      alert(error.description || 'Could not add item to cart.');
      return;
    }

    window.location.href = '/cart';
  };
});